<template>
  <div
    :id="`block-${block.id}`"
    :style="outerStyles"
    :class="outerClasses"
    @mousedown="setCurrentEditor"
  >
    <div class="relative h-full w-full" data-inline-svg="false">
      <!-- Text -->
      <div v-if="block.block_type == 'text' && isThumbnail" data-type="text">
        <ContentEditor :content="block.html_content" :is-thumbnail="isThumbnail" />
      </div>

      <div v-else-if="block.block_type == 'text'" data-type="text" ref="blockRef">
        <ContentEditor :content="block.html_content" :onUpdate="(html) => onBlockUpdate(html, 'html_content')" @editor-created="updateEditor" :is-thumbnail="isThumbnail" />
      </div>

      <!-- Spark -->
      <SparkPreview v-else-if="block.has_spark" :block="block" :is-thumbnail="isThumbnail" />
      <SparkPlaceholder v-else-if="block.has_spark" :spark_image_url="block.spark_image_url" :block="block" />

      <!-- Section -->
      <Section v-else-if="block.block_type == 'section'" :section="block.section" :block="block" :is-thumbnail="isThumbnail" />

      <!-- Embed -->
      <Embed v-else-if="block.block_type == 'embed'" :block="block" :is-thumbnail="isThumbnail" />

      <!-- Image w/attachment -->
      <div v-else-if="isImageWithAttachment" class="relative w-full h-full object-cover rounded-lg overflow-hidden p-6" :style="block.inner_style">
        <img :src="imageSource" class="w-full h-full object-cover rounded-lg" :style="block.image_frame_style" />
        <ImageUploadOverlay v-if="block.editable" :block="block" wrapperClasses="p-6" />
      </div>

      <!-- Image w/o attachment -->
      <div v-else-if="isImageWithoutAttachment" class="flex h-full w-full justify-center items-center p-6">
        <img :src="imageSource" class="w-full h-full object-cover rounded-lg" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject } from 'vue'
import { useBlockHelpers } from '../../../composables/useBlockHelpers'
import { useContentEditor } from '../../../composables/useContentEditor'
import { useBlockUpdate } from '../../../composables/useBlockUpdate'
import SparkPlaceholder from './SparkPlaceholder.vue'
import SparkPreview from './SparkPreview.vue'
import Embed from './Embed.vue'
import Section from './Section.vue'
import ContentEditor from '../../editor/ContentEditor.vue'
import ImageUploadOverlay from '../../images/ImageUploadOverlay.vue'

export default {
  name: 'RelativeBlock',
  props: {
    block: {
      type: Object,
      required: true
    },
    isThumbnail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SparkPlaceholder,
    SparkPreview,
    Embed,
    Section,
    ContentEditor,
    ImageUploadOverlay
  },
  setup(props) {
    const { parseStyleString, isImageWithAttachment, isImageWithoutAttachment } = useBlockHelpers(props.block)
    const { setCurrentEditor, updateEditor, blockRef } = useContentEditor(props.block)
    const { onBlockUpdate } = useBlockUpdate(props.block)
    const featureFlags = inject('featureFlags')

    const outerStyles = computed(() => ({
      ...parseStyleString(props.block.outer_style),
      position: 'unset'
    }))

    const outerClasses = computed(() => [
      'wellio-block',
      'block',
      'text-inherit',
      'h-full',
      'w-full',
      `self-${props.block.align}`,
      `justify-self-${props.block.justify}`,
      `z-100`
    ])

    const imageSource = computed(() => {
      return props.isThumbnail ? props.block.static_image_url : props.block.image_url
    })

    return {
      outerStyles,
      outerClasses,
      isImageWithAttachment,
      isImageWithoutAttachment,
      setCurrentEditor,
      updateEditor,
      blockRef,
      onBlockUpdate,
      imageSource,
      featureFlags
    }
  }
}
</script>
